<template>
    <DCard
        padding
    >
        <Form
            :email-verification-settings="emailVerificationSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/EmailVerificationSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    emailVerificationSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const submitData = function (form) {
    form.post(route('settings.email-verification-settings.store'))
}
</script>
